import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/**
 * Shell for signed-out pages (sign in, invite, password reset): brand panel on
 * wide screens, one centred card. One of the few places the brand gradient appears.
 */
export function AuthLayout({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-dvh lg:grid-cols-2">
      <aside className="relative hidden flex-col justify-between bg-gradient-hero p-12 text-on-primary lg:flex">
        <img src="/brand/ts-wordmark-white.png" alt="TeamSystem" className="h-8 w-auto self-start" />
        <div>
          <p className="font-heading text-4xl font-bold leading-tight">{t("app.name")}</p>
          <p className="mt-3 max-w-md text-lg opacity-90">{t("app.tagline")}</p>
        </div>
        <div aria-hidden="true" className="h-2 w-full rounded-full bg-gradient-brand" />
      </aside>

      <main className="flex items-center justify-center bg-bg p-6">
        <div className="w-full max-w-sm rounded-lg bg-surface p-8 shadow-card">
          <img src="/brand/ts-mark.jpeg" alt="" className="mb-6 h-10 w-10 rounded-sm" />
          <h1 className="text-2xl font-bold text-primary">{title}</h1>
          {subtitle ? <p className="mt-1 text-sm text-fg-muted">{subtitle}</p> : null}
          <div className="mt-6">{children}</div>
        </div>
      </main>
    </div>
  );
}

export function FormError({ message }: { message?: string | undefined }) {
  if (!message) return null;
  return (
    <p role="alert" className="mt-4 rounded-sm bg-danger-bg px-3 py-2 text-sm text-danger">
      {message}
    </p>
  );
}

export function FormNotice({ message }: { message: string }) {
  return (
    <p role="status" className="rounded-sm bg-success-bg px-3 py-2 text-sm text-success">
      {message}
    </p>
  );
}
